// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#site-header {
	height: 52px;
	background-color: #a9dca9;
}

#site-header .site-header__content {
	padding: 12px 5vw;
}

#site-header .site-header__title {
	position: relative;
	top: -32px;
	z-index: 1;
	width: 100%;
	margin: 0;
	text-align: center;
}

#site-header .site-header__title a {
	text-decoration: none;
	color: #fff;
}

#site-header .site-header__logo-wrapper {
	position: absolute;
	top: 12px;
	right: 5vw;
	z-index: 2;
}

#site-header .site-header__logo-wrapper img {
	height: 30px;
}
`, "",{"version":3,"sources":["webpack://./src/css/components/SiteHeader/SiteHeader.css"],"names":[],"mappings":"AAAA;CACC,YAAY;CACZ,yBAAyB;AAC1B;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;CACV,WAAW;CACX,SAAS;CACT,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,UAAU;AACX;;AAEA;CACC,YAAY;AACb","sourcesContent":["#site-header {\n\theight: 52px;\n\tbackground-color: #a9dca9;\n}\n\n#site-header .site-header__content {\n\tpadding: 12px 5vw;\n}\n\n#site-header .site-header__title {\n\tposition: relative;\n\ttop: -32px;\n\tz-index: 1;\n\twidth: 100%;\n\tmargin: 0;\n\ttext-align: center;\n}\n\n#site-header .site-header__title a {\n\ttext-decoration: none;\n\tcolor: #fff;\n}\n\n#site-header .site-header__logo-wrapper {\n\tposition: absolute;\n\ttop: 12px;\n\tright: 5vw;\n\tz-index: 2;\n}\n\n#site-header .site-header__logo-wrapper img {\n\theight: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
